import moment from "moment-timezone";

import { Apollo } from "@/decorators";
import { User } from "../../../../types";
import UPDATE_PAY_SLIP_DOCUMENT_MUTATION from "../../graphql/document/UpdatePaySlipDocument.gql";
import COMPANY_USERS from "../../graphql/user/PartOfCompanyUsers.gql";

import CompanyTableComponent from "../admin/CompaniesTable.vue";
import { getNextNoValidatedDocumentId } from "./DocumentValidationSpeedRun.helper";
import Chat from "../chat/Chat.vue";
import { DocumentBase } from "./DocumentBase";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { Component, Watch } from "vue-facing-decorator";
import { mathFix } from "../../services/mathServices";

const precision = 0.1;

@Component({
    components: {
        companyTable: CompanyTableComponent,
        Chat,
    },
})
export class DocumentValidationPaySlipBase extends DocumentBase {
    get advice() {
        return "valider le document";
    }

    activeTab: "document" | "accountingLines" | "activity" = "document";

    showAccountingLines = false;

    accountingLinesLockedDialog = false;

    valid = false;

    validated = false;

    loading = false;

    updating = false;

    // dialogSelectCompany = false;

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.users) {
                    this.currentAccountUsers = data.users;
                    this.updateCurrentAccountUser();
                }
            }
        },
    })
    currentAccountUsers: User[] = [];

    getUsers() {
        return this.currentAccountUsers;
    }

    get subjectToVAT() {
        return !isNotSubjectToVAT(this.selectedCompany.vatSystem);
    }

    get dateList() {
        const dateList = [];
        this.svgVariants.forEach((variant) => {
            if (variant.type === "DATE") dateList.push(this.formatDate(variant.value));
        });
        return dateList;
    }

    get invoiceNumberList() {
        const invoiceNumberList = [];
        this.svgVariants.forEach((variant) => {
            if (variant.type === "INVOICENUMBER") invoiceNumberList.push(variant.value);
        });
        return invoiceNumberList;
    }

    confidence(meta: any) {
        return Math.round(meta.confidence * 100) || null;
    }

    dateDialog: boolean = false;
    // date:string = ""

    onDateChangeFromDatePicker() {
        this.form.date.validated = true;
    }

    onFieldAssociation(selectedField: any, propertyName: string) {
        this.cleanVariant(selectedField);
        selectedField.index = this.activePolygon.index;
        this.svgVariants[selectedField.index].active = true;
        selectedField.value =
            this.svgVariants[selectedField.index].type === "NUMBER" ||
            this.svgVariants[selectedField.index].type === "PERCENTAGE"
                ? +parseFloat(this.svgVariants[selectedField.index].value)
                : this.svgVariants[selectedField.index].value;
        selectedField.validated = true;
        this.associatedFields.fields = {};
        this.hideVariantList();
        this.zoomManager.resetZoom();
    }

    priceTextColor(amount: any) {
        return amount && amount.value;
    }

    buildMetadata(document: any, key: string, valueType = "number") {
        document[`${key}_variants`] = [];
        let variantIndex = null;
        if (this.analysis) {
            if (key && this.analysis.results[key]) {
                this.analysis.results[key].variants.forEach((val) => {
                    // val.confidence *= 100
                    document[`${key}_variants`].push(val);
                });

                document[`${key}_variants`].forEach((variant) => {
                    this.svgVariants[variant.index].fieldNames.push({
                        name: key.replace("single_", ""),
                        confidence: variant.confidence,
                    });
                });
            }

            if (key && this.analysis.results[key]) {
                const coordinates = [];
                const variant =
                    this.analysis.values[
                        this.analysis.results[key].variants[this.analysis.results[key].variantIndex]
                            .index
                    ];
                if (variant.boxes.length > 0) {
                    variant.boxes.forEach((box) => {
                        if (box.vertices.length > 0) coordinates.push(box.vertices);
                    });
                }
                if (!document[key]) {
                    document[key] =
                        valueType === "number"
                            ? mathFix(parseFloat(variant.value), 4)
                            : variant.value;
                }
                document[`${key}_coordinates`] = coordinates;
                // variantIndex = this.analysis.results[key].variantIndex
                variantIndex = document[`${key}_coordinates`]
                    ? this.svgVariants.findIndex((elem: any) => {
                          if (valueType === "number")
                              return parseFloat(elem.value) === document[`${key}`];
                          if (valueType === "date") {
                              console.log(
                                  elem.value === moment(document[`${key}`]).format("YYYY-MM-DD"),
                                  elem.value,
                                  moment(document[`${key}`]).format("YYYY-MM-DD"),
                              );
                              return elem.value === moment(document[`${key}`]).format("YYYY-MM-DD");
                          }
                          return elem.value === document[`${key}`];
                      })
                    : null;
                if (key === "date") {
                    console.log("variant index", variantIndex);
                }
            }
        }

        return {
            value: document[`${key}`]
                ? document[`${key}`]
                : document[`${key}Auto`]
                  ? document[`${key}Auto`]
                  : 0.0,
            validatedValue: document[`${key}`] || null,
            validated: document[`${key}`] !== null,
            // ||
            // (document[`${key}_confidence`] !== null &&
            //     document[`${key}_confidence`] > 90),
            index: variantIndex,
        };
        // if (valueType === "number") {
        //     if (meta.value) {
        //         meta.value = parseFloat(meta.value);
        //     }
        // }
        // return meta
    }

    beforeMount() {
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    get allPricesValidated() {
        return true;
    }

    get disabledValidate() {
        if (!this.form?.date?.validated) return true;
        // if (this.otherOnlineUsersWrite) return true;
        // if ((this.document.type === 'SALES_INVOICE' && (!this.document.thirdPartyCompany || !this.document.thirdPartyCompany.id))) return true;
        // if ((!this.document.thirdPartyCompany || !this.document.thirdPartyCompany.id)) return true;
        // if (this.subjectToVAT) {
        //     return !this.form.allPricesValidated;
        // }
        return false;
    }

    async onFormValidation() {
        // @ts-ignore
        if (this.disabledValidate) return;
        // return;
        this.loading = true;
        this.updating = true;

        let name = "OD de paie : ";
        name += this.currentAccountUser.firstname + " " + this.currentAccountUser.lastname;

        const data = JSON.parse(JSON.stringify(this.inDocument.data));

        if (data && data.paySlip) {
            for (const key in this.form) {
                if (data.paySlip[key] !== undefined) {
                    data.paySlip[key] = this.form[key].value || 0.0;
                }
            }
        }

        debugger;

        const docResult = await this.$apollo.mutate({
            mutation: UPDATE_PAY_SLIP_DOCUMENT_MUTATION,
            variables: {
                documentId: this.documentId,
                name: name,
                ownerId: this.currentAccountUser.id,
                status: "VALIDATED",
                data: data,
            },
        });

        this.updating = false;
        this.loading = false;
        this.validated = true;

        await this.createUserActivity(this.document.id, "UPDATE");

        const store_documentParams = this.$store.state?.documentFilter ?? {};
        if (store_documentParams?.switchToNextNoValidatedDocumentAfterValidation) {
            const nextDocumentId = await getNextNoValidatedDocumentId(
                this.$apollo,
                this.getWhere(),
            );
            if (nextDocumentId?.length) {
                if (nextDocumentId === "_") {
                    this.lastDocumentValidationDone = true;
                } else {
                    this.prevNext.nextId = nextDocumentId;
                    this.next();
                }
            }
        } else {
            this.startToBeDoneIfNecessary();
        }
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        if (prev !== next) {
            await this.getAnalysis();
            this.clearVariantList();
            this.updateForm(this.inDocument);
            if (this.document.signedUrl && !this.isPDF) {
                this.zoomManager.instanciateSvgZoom(this.svgSuffix);
            }
            this.finishMounted();
        }
    }

    updateForm(document: any) {
        this.document = this.inDocument;
        // this.dueDate = document.dueDate || document.date || document.dateAuto;
        this.updateCurrentAccountUser();

        if (this.document.status.startsWith("ANALYSED")) {
            this.validated = false;
        } else {
            this.validated = true;
        }

        document.variants = [];
        if (this.analysis && this.analysis.values) {
            this.analysis.values.forEach((variant) => {
                const coordinates: any = [];
                if (variant.boxes.length > 0) {
                    variant.boxes.forEach((box) => {
                        if (box.vertices.length > 0) coordinates.push(box.vertices);
                    });
                }
                document.variants.push({
                    value: variant.value,
                    type: variant.type,
                    coordinates: coordinates,
                });
            });
        }

        // console.log("heheheh", document.signedUrl);
        this.computeSVGVariants(document);

        this.form = {
            date: this.buildMetadata(document, "date", "date"),
            // socialSecurityNumber: { type: "SOCIALSECURITYNUMBER"},
            grossSalary: this.buildMetadata(document, "grossSalary"),
            //
            salaryCharges: this.buildMetadata(document, "salaryCharges"),
            nonDeductibleCSGCRDS: this.buildMetadata(document, "nonDeductibleCSGCRDS"),
            hshc: this.buildMetadata(document, "hshc"),
            //
            navigo: this.buildMetadata(document, "navigo"),
            benefitInKind: this.buildMetadata(document, "benefitInKind"),
            luncheonVoucher: this.buildMetadata(document, "luncheonVoucher"),
            employerLoan: this.buildMetadata(document, "employerLoan"),
            thirdPartyNotification: this.buildMetadata(document, "thirdPartyNotification"),
            //
            netSalaryBeforeTax: this.buildMetadata(document, "netSalaryBeforeTax"),
            incomeTax: this.buildMetadata(document, "incomeTax"),
            netSalaryPaid: this.buildMetadata(document, "netSalaryPaid"),
            employerCharges: this.buildMetadata(document, "employerCharges"),
            totalCost: this.buildMetadata(document, "totalCost"),
        };
        if (this.inDocument.data && this.inDocument.data.paySlip) {
            const data = this.inDocument.data.paySlip;
            for (const key in this.form) {
                if (key !== "date") {
                    const value = data[key];
                    if (value !== undefined) {
                        this.form[key].value = value;
                    }
                }
            }
        }
    }

    @Watch("form", { deep: true })
    onFormUpdate(current: any) {
        // console.log("on form updateeee");
        let index = null;
        if (current) {
            Object.keys(current).forEach((k) => {
                if (k !== "allPricesValidated") {
                    if (["single_prices", "multi_prices"].includes(k)) {
                        Object.keys(current[k]).forEach((k2: any) => {
                            Object.keys(current[k][k2]).forEach((k3: any) => {
                                this.cleanVariant(current[k][k2][k3]);
                                let conf: any = 0;
                                index = this.svgVariants.findIndex((variant) => {
                                    if (
                                        variant.fieldNames.some((el) => {
                                            conf = el.confidence;
                                            return el.name === k3;
                                        }) &&
                                        !variant.active
                                    ) {
                                        return +variant.value === +current[k][k2][k3].value;
                                    }
                                    return false;
                                });
                                if (index >= 0) {
                                    this.svgVariants[index].active = true;
                                    this.svgVariants[index].focus = false;
                                    current[k][k2][k3].index = index;
                                    current[k][k2][k3].confidence = conf;
                                } else {
                                    current[k][k2][k3].index = null;
                                    current[k][k2][k3].confidence = null;
                                }
                            });
                        });
                    } else {
                        this.cleanVariant(this.form[k]);
                        const conf: any = 0;
                        // index = this.svgVariants.findIndex((variant) => {
                        //     if (
                        //         variant.fieldNames.some((el) => {
                        //             conf = el.confidence;
                        //             return el.name === k;
                        //         }) &&
                        //         !variant.active
                        //     ) {
                        //         return variant.value === current[k].value;
                        //     }
                        //     return false;
                        // });
                        index = this.form[k].index;
                        if (index >= 0 && this.svgVariants?.[index]) {
                            this.svgVariants[index].active = true;
                            this.svgVariants[index].focus = false;
                            current[k].index = index;
                            current[k].confidence = conf;
                        } else {
                            current[k].index = null;
                            current[k].confidence = null;
                        }
                    }
                }
            });
        }
        this.$forceUpdate();
    }

    // navigo                 =                                                                           | 624700
    // benefitInKind          =                                                                           | 648000
    // luncheonVoucher        =                                                                           | 641400
    // employerLoan           =                                                                           | 425000
    // thirdPartyNotification =                                                                           | 427000
    // miscelleanous          = -navigo - luncheonVoucher - benefitInKind - employerLoan + thirdPartyNotification
    //
    // grossSalary            = netSalaryBeforeTax + salaryCharges + miscelleanous                        | 641000
    // salaryCharges          = grossSalary - netSalaryBeforeTax - miscelleanous                          |
    // nonDeductibleCSGCRDS   =
    // hshc                   =
    // netSalaryBeforeTax     = grossSalary - salaryCharges - miscelleanous                               |
    //
    // netSalary              = netSalaryPaid - employerLoan - thirdPartyNotification                     | 421000
    //
    // incomeTax              = netSalaryBeforeTax - netSalaryPaid                                        | 442100
    // netSalaryPaid          = netSalaryBeforeTax - incomeTax                                            |
    //
    // employerCharges        = totalCost - grossSalary - navigo - luncheonVoucher - benefitInKind        | 645800
    // totalCost              = grossSalary + employerCharges + navigo + luncheonVoucher + benefitInKind
    // totalCharges           = salaryCharges + employerCharges                                           | 437000

    get navigo() {
        if (this.form.navigo.value) return this.form.navigo.value;
        return 0;
    }

    get luncheonVoucher() {
        if (this.form.luncheonVoucher.value) return -this.form.luncheonVoucher.value;
        return 0;
    }

    get benefitInKind() {
        if (this.form.benefitInKind.value) return -this.form.benefitInKind.value;
        return 0;
    }

    get employerLoan() {
        if (this.form.employerLoan.value) return -Math.abs(this.form.employerLoan.value);
        return 0;
    }

    get thirdPartyNotification() {
        if (this.form.thirdPartyNotification.value) return -this.form.thirdPartyNotification.value;
        return 0;
    }

    get miscelleanous() {
        let miscelleanous = 0.0;
        miscelleanous -= this.navigo;
        miscelleanous -= this.luncheonVoucher;
        miscelleanous -= this.benefitInKind;
        miscelleanous -= this.employerLoan;
        miscelleanous += this.thirdPartyNotification;

        return miscelleanous;
    }

    get totalSalaryCharges() {
        let salaryCharges = this.form.salaryCharges.value;
        const diff =
            this.form.grossSalary.value -
            salaryCharges -
            this.form.netSalaryBeforeTax.value -
            this.miscelleanous;
        if (Math.abs(diff) > 1e-2) {
            const hshc = this.form.hshc.value;
            const nonDeductibleCSGCRDS = this.form.nonDeductibleCSGCRDS.value;
            let diffFound = false;
            if (hshc && nonDeductibleCSGCRDS) {
                if (Math.abs(diff - nonDeductibleCSGCRDS - hshc) < precision) {
                    salaryCharges += nonDeductibleCSGCRDS + hshc;
                    diffFound = true;
                    debugger;
                }
            }
            if (!diffFound && hshc) {
                if (Math.abs(diff - hshc) < precision) {
                    salaryCharges += hshc;
                    diffFound = true;
                    debugger;
                }
            }
            if (!diffFound && nonDeductibleCSGCRDS) {
                if (Math.abs(diff - nonDeductibleCSGCRDS) < precision) {
                    salaryCharges += nonDeductibleCSGCRDS;
                    diffFound = true;
                    debugger;
                }
            }
        }
        return salaryCharges;
    }

    get totalCharges() {
        return this.totalSalaryCharges + this.form.employerCharges.value;
    }

    get totalNet() {
        let total = 0.0;
        total += this.navigo;
        total += this.benefitInKind;
        total += this.luncheonVoucher;
        if (this.form.grossSalary.value) total += this.form.grossSalary.value;
        if (this.form.employerCharges.value) total += this.form.employerCharges.value;
        return total;
    }

    get totalGross() {
        let total = 0.0;
        if (this.form.employerLoan.value) total -= this.employerLoan;
        if (this.form.thirdPartyNotification.value) total += this.thirdPartyNotification;
        if (this.form.incomeTax.value) total += this.form.incomeTax.value;
        if (this.form.netSalaryPaid.value) total += this.form.netSalaryPaid.value;
        total += this.totalCharges;
        return total;
    }

    get isBalanced() {
        return Math.abs(this.totalNet - this.totalGross) < precision;
    }

    // get isGrossSalaryValid() {
    //     return Math.abs(this.form.totalCost.value - (this.form.grossSalary.value + this.form.navigo.value + this.form.employerCharges.value)) < 1.e-2
    // }

    get isNetSalaryBeforeTaxValid() {
        if (this.form.netSalaryBeforeTax.value === "") return false;
        if (this.form.incomeTax.value === "") return false;
        if (this.form.netSalaryPaid.value === "") return false;
        return (
            Math.abs(
                this.form.netSalaryBeforeTax.value -
                    (this.form.incomeTax.value + this.form.netSalaryPaid.value),
            ) < 1e-2
        );
    }

    onMetadataChange(priceType: any, propertyName: string) {}
}
